import React from 'react'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import Head from 'next/head'
import utc from 'dayjs/plugin/utc'
import { useRouter } from 'next/router'

import 'dayjs/locale/id'

import { useGetKeyPairValue } from 'api/microlearning/useAPIKeyValue'
import WebinarCard, { WebinarPreloader } from '../partials/Webinar/WebinarCard'
import { MILKvKeys } from 'api/microlearning/useAPIKeyValue'
import { EmptyState, EmptyStateAction } from 'components/EmptyState'

import type { Webinar } from '../partials/Webinar/WebinarCard'

dayjs.extend(utc)
dayjs.extend(timezone)
dayjs.locale('id')

const minutesBefore = 30
const WebinarList = () => {
  const { data, status } = useGetKeyPairValue(MILKvKeys.WebinarEntries)
  const wibTime = dayjs().tz('Asia/Jakarta')
  const router = useRouter()

  return (
    <>
      <Head>
        <title>Daftar Webinar</title>
      </Head>
      <div
        className="overflow-y-auto"
        style={{ height: 'calc(100vh - 3.5rem)' }}
      >
        <div className="px-4 pt-4">
          {status === 'loading' &&
            [...Array(4)].map((index) => (
              <div key={index} className="mb-4">
                <WebinarPreloader />
              </div>
            ))}
          {status === 'success' &&
            !!data?.data?.webinar &&
            data.data.webinar.map(
              ({ id, title, topic, speakers, startDate, endDate }: Webinar) =>
                wibTime.isBefore(
                  dayjs(endDate).add(minutesBefore, 'minute')
                ) ? (
                  <div key={id} className="mb-4">
                    <WebinarCard
                      id={id}
                      href={`/pelatihan-mandiri/webinar/${id}`}
                      topicId={topic?.id as unknown as string}
                      topicName={topic?.title}
                      title={title}
                      speakers={speakers}
                      startDate={startDate}
                      endDate={endDate}
                    />
                  </div>
                ) : null
            )}
          {status === 'success' &&
            data.data?.webinar?.filter(({ endDate }) =>
              wibTime.isBefore(dayjs(endDate).add(minutesBefore, 'minute'))
            ) <= 0 && (
              <EmptyState
                title="Tidak ada Webinar"
                description="Belum ada Webinar yang akan berlangsung untuk saat ini, silakan coba akses halaman ini lagi di lain waktu"
              >
                <EmptyStateAction onClick={() => router.back()}>
                  Kembali
                </EmptyStateAction>
              </EmptyState>
            )}
        </div>
      </div>
    </>
  )
}

export default WebinarList
